import html from '../Images/skills/html.svg'
import photoshop from '../Images/skills/photoshop.svg'
import css from '../Images/skills/css.svg'
import javascript from '../Images/skills/javascript.svg'
import nextJS from '../Images/skills/nextJS.svg'
import nuxtJS from '../Images/skills/nuxtJS.svg'
import react from '../Images/skills/react.svg'
import svelte from '../Images/skills/svelte.svg'
import typescript from '../Images/skills/typescript.svg'
import vue from '../Images/skills/vue.svg'
import bootstrap from '../Images/skills/bootstrap.svg'
import bulma from '../Images/skills/bulma.svg'
import capacitorjs from '../Images/skills/capacitorjs.svg'
import coffeescript from '../Images/skills/coffeescript.svg'
import memsql from '../Images/skills/memsql.svg'
import mongoDB from '../Images/skills/mongoDB.svg'
import mysql from '../Images/skills/mysql.svg'
import postgresql from '../Images/skills/postgresql.svg'
import tailwind from '../Images/skills/tailwind.svg'
import vitejs from '../Images/skills/vitejs.svg'
import vuetifyjs from '../Images/skills/vuetifyjs.svg'
import c from '../Images/skills/c.svg'
import cplusplus from '../Images/skills/cplusplus.svg'
import csharp from '../Images/skills/csharp.svg'
import dart from '../Images/skills/dart.svg'
import go from '../Images/skills/go.svg'
import java from '../Images/skills/java.svg'
import julia from '../Images/skills/julia.svg'
import kotlin from '../Images/skills/kotlin.svg'
import matlab from '../Images/skills/matlab.svg'
import php from '../Images/skills/php.svg'
import python from '../Images/skills/python.svg'
import ruby from '../Images/skills/ruby.svg'
import swift from '../Images/skills/swift.svg'
import adobeaudition from '../Images/skills/adobeaudition.svg'
import aws from '../Images/skills/aws.svg'
import deno from '../Images/skills/deno.svg'
import django from '../Images/skills/django.svg'
import firebase from '../Images/skills/firebase.svg'
import gimp from '../Images/skills/gimp.svg'
import git from '../Images/skills/git.svg'
import graphql from '../Images/skills/graphql.svg'
import lightroom from '../Images/skills/lightroom.svg'
import materialui from '../Images/skills/materialui.svg'
import nginx from '../Images/skills/nginx.svg'
import numpy from '../Images/skills/numpy.svg'
import opencv from '../Images/skills/opencv.svg'
import premierepro from '../Images/skills/premierepro.svg'
import pytorch from '../Images/skills/pytorch.svg'
import selenium from '../Images/skills/selenium.svg'
import strapi from '../Images/skills/strapi.svg'
import tensorflow from '../Images/skills/tensorflow.svg'
import webix from '../Images/skills/webix.svg'
import wordpress from '../Images/skills/wordpress.svg'

import postman from '../Images/skills/postman.svg'
import azure from '../Images/skills/azure.svg'
import blender from '../Images/skills/blender.svg'
import fastify from '../Images/skills/fastify.svg'
import figma from '../Images/skills/figma.svg'
import flutter from '../Images/skills/flutter.svg'
import haxe from '../Images/skills/haxe.svg'
import ionic from '../Images/skills/ionic.svg'
import markdown from '../Images/skills/markdown.svg'
import microsoftoffice from '../Images/skills/microsoftoffice.svg'
import picsart from '../Images/skills/picsart.svg'
import sketch from '../Images/skills/sketch.svg'
import unity from '../Images/skills/unity.svg'
import wolframalpha from '../Images/skills/wolframalpha.svg'
import canva from '../Images/skills/canva.svg'
import redux from '../Images/skills/redux.svg'
import npm from '../Images/skills/npm.svg'
import express from '../Images/skills/express.svg'
import node from '../Images/skills/node.svg'
import netlify from '../Images/skills/netlify.svg'
import heroku from '../Images/skills/heroku.svg'
import styled from '../Images/skills/styled.svg'

export const FrontEndSkills={"HTML":html,"CSS":css,JavaScripts:javascript,BootStrap:bootstrap,React:react,Redux:redux}
// NextJs:nextJS
export const BackEndSkills = {Node:node,"Mongo DB":mongoDB,Express:express,"NPM":npm}
  

export const Tools = {Heroku:heroku,Netlify:netlify,Canva:canva,Postman:postman,Git:git}
